module.exports = __webpack_public_path__ + "static/media/role1m.469794bd.webp";